import { FC, useEffect, useState } from "react";
import styles from './index.module.less';
import { Breadcrumb } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { getNotificationDetail } from "../../api";

const Index: FC = (props) => {
    const { id } = useParams();
    const navigate = useNavigate()
    const [data, setData] = useState(
            {
                title: '',
                content: '',
                fileName: '',
                url: '',
                time: ''
            }
        );

    const getData = async (id) => {
        const res = await getNotificationDetail(id);
        setData({
            title: res.title,
            content: res.content,
            fileName: res.attachment_name,
            url: res.attachment_url,
            time: res.time
        });
    }

    useEffect(() => {
        if (id != undefined) {
            getData(id);
        }
    }, [id]);
    return (
        <div className={styles.body}>
            <div style={{width: '960px'}}>
                <div className={styles.navbar}>
                    <Breadcrumb>
                        <Breadcrumb.Item className={styles.bread} onClick={() => navigate('/')}>首页</Breadcrumb.Item>
                        <Breadcrumb.Item className={styles.bread} onClick={() => navigate('/notification')}>通知公告</Breadcrumb.Item>
                        <Breadcrumb.Item>{data.title}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className={styles.content}>
                    <div className={styles.title}>{data.title}</div>
                    <div className={styles.time}>{data.time}</div>
                    <div className={styles.article} dangerouslySetInnerHTML={{ __html: data.content }} />
                    {
                        data?.url != undefined && data?.url != '' &&
                        <a download href={data.url}>{data?.fileName ? data?.fileName : '附件'}</a>
                    }
                </div>
            </div>
        </div>
    );
}

export default Index;